<template>
  <el-select v-model="option.value">
    <el-option v-for="item in option.items" :key="item.id" :value="item.id" :label="item.content.text" />
  </el-select>
</template>

<script>
export default {
  name: 'MatrixSelectContent',
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped></style>
